// extracted by mini-css-extract-plugin
module.exports = {"input":"Search_input__2RdV5","styledIcon":"Search_styledIcon__2BTz5","wrapper":"Search_wrapper__9S6WY"};